export default __webpack_public_path__ + "static/media/suggestion-chips-watson-actions3.598c3bc0.png";